import { EditorClient } from './client/EditorClient';
class SocketManager {
    editorClient;
    getEditorClient() {
        if (!this.editorClient) {
            this.editorClient = new EditorClient();
        }
        return this.editorClient;
    }
    getEditorClientSocket() {
        return this.getEditorClient().socket;
    }
    disconnectEditorClient() {
        if (!this.editorClient) {
            return;
        }
        this.editorClient.disconnectClient();
    }
}
const WegicSocket = new SocketManager();
export { WegicSocket };
